<template>
  <div class="inventario">
    <vuestic-widget header-text="App Inventario">
      <button class="btn btn-micro btn-warning" @click="modal">Generar Inventario</button>
      <hr>
      <modal-inventario @creacionInventario="update" ref="modalInventario" />
      <tabla-inventario ref="tablaInventario" />
    </vuestic-widget>
  </div>
</template>

<script>
import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
import InputComp from "../../Componentes_Globales/Input/inputComp";
import VuesticMultiSelect from "../../../vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect";
import TablaInventario from "../Components/tablaInventario";
import ModalInventario from "components/Sucursales/Components/modalInventario";

export default {
  name: "inventario",
  components: {ModalInventario, TablaInventario, VuesticMultiSelect, InputComp, VuesticModal, VuesticWidget},
  created() {
    this.$store.dispatch("loadUsuarios")
  },
  methods: {
    modal() {
      this.$refs.modalInventario.openModal()
    },
    update() {
      this.$refs.tablaInventario.getInventarios()
    }
  },
}
</script>

<style scoped>
</style>
